import { onResponse } from '~/composables/useRequest'
import { useCityInfoStore } from '~/stores/useCityInfo'
import { useRouter } from 'vue-router'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  // const { _route } = nuxtApp
  const cityInfoStore = useCityInfoStore()
  const fetch = $fetch.create({
    timeout: 1000 * 20,
    onRequest({ options, request }) {
      // 添加baseURL,nuxt3环境变量要从useRuntimeConfig里面取
      // 访问 useRuntimeConfig 须在 NuxtInstance 实例中
      // const { public: { apiBase } } = useRuntimeConfig()
      // options.baseURL = apiBase
      // options.method = options.method || 'get'
      // 添加请求头,没登录不携带token
      // const userStore = useUserStore()
      // if (!userStore.isLogin)
      //   return
      options.headers = new Headers(options.headers)
      /**
       * 如果当前页params中存在floorId：
       * 1、存在queryValue?.preview的时候将preview=1使用floorId作为键存入cookie，失效时间10分钟
       * 2、如果query中存在preview=1且params中存在floorId，则给接口添加头preview+floorId = 1
       * 3、如果query中不存在preview=1，则从cookie中获取当前页面的floorId对应的preview是否存在，如果存在则给接口添加头preview+floorId = 1，不存在则不错处理
       */
      const queryValue = router?.currentRoute.value?.query
      const paramsValue = router?.currentRoute.value?.params
      if (queryValue?.preview === '1' && paramsValue?.floorId) {
        useCookie(`preview${paramsValue?.floorId}`, { maxAge: 10 * 60 }).value = '1'
        options?.headers.set(`preview${paramsValue?.floorId}`, '1')
      } else if (paramsValue?.floorId) {
        const preview = useCookie(`preview${paramsValue?.floorId}`).value
        if (preview) {
          options?.headers.set(`preview${paramsValue?.floorId}`, preview)
        }
      }
      // 将老M版中存放的token从cookie中取出
      const cookie = useCookie('accessToken')
      const refreshToken = useCookie('refreshToken')
      options.headers.set('RefreshToken', refreshToken.value || '')
      // const EnvConfig = useRuntimeConfig()
      // options.headers.set(EnvConfig.public.authorizationName, cookie.value || '')
      options.headers.set('Authorization', cookie.value || '')
      options.headers.set('CityId', cityInfoStore.city || '')
      // 是否服务端请求
      // eslint-disable-next-line node/prefer-global/process
      if (process.server) {

        // console.log('options', JSON.stringify(options))
        // console.log('request', request)
      }
    },
    onResponse: (ctx) => {
      onResponse(ctx)
    },
    // onResponse({ response }) {
    //   const data = response._data
    //   // 是否服务端请求
    //   // eslint-disable-next-line node/prefer-global/process
    //   if (process.server)
    //   // eslint-disable-next-line no-console
    //     console.log('response._data', JSON.stringify(data))

    //   // 登录逻辑
    //   // const { $login } = nuxtApp
    //   // // 处理用户信息过期
    //   // const hanlerTokenOverdue = async () => {
    //   //   const { _route } = nuxtApp
    //   //   // await $login(_route?.fullPath)
    //   // }
    //   //
    //   // // 处理报错异常
    //   // const handlerError = (msg = '服务异常') => {
    //   //   // eslint-disable-next-line node/prefer-global/process,style/max-statements-per-line
    //   //   if (process.server) { showError({ message: msg, statusCode: 500 }) }
    //   //   else {
    //   //     showToast({
    //   //       message: msg,
    //   //     })
    //   //   }
    //   // }
    //   // const error = response._data.error
    //   // const responseData = response._data as DefaultResult<T>
    //   // const { ignoreCatch, ignoreGlobalErrorMessage } = options // 忽略全局
    //   // if (error || !responseData) {
    //   //   if (!ignoreGlobalErrorMessage)
    //   //     handlerError()
    //   //   return reject(error.value || '服务响应失败，请稍后重试')
    //   // }
    //   // else {
    //   //   const { code, dataBody: result, message } = responseData
    //   //   // 接口请求成功，直接返回结果
    //   //   if (ResultEnum.SUCCESS.split(',').includes(code?.toString()) || !code) {
    //   //     return resolve(responseData)
    //   //   }
    //   //
    //   //   if (!ignoreCatch) {
    //   //     // 接口请求错误，统一处理
    //   //     switch (code) {
    //   //       case ResultEnum.TOKEN_OVERDUE: // 登录信息过期，去登录
    //   //         // 用户信息过期
    //   //         await hanlerTokenOverdue()
    //   //
    //   //       default:
    //   //         if (!ignoreGlobalErrorMessage)
    //   //           handlerError(message)
    //   //         return reject(message || '服务响应失败，请稍后重试')
    //   //     }
    //   //   }
    //   // }
    //   // 如果不是服务端请求且未登录则跳转到登陆页面
    //   if (!process.server && data.code === ResultEnum.NOTLOGININ)
    //     window.location.href = `/member/mobileLogin?redirect=${_route.fullPath}`
    //   //  api5
    //   if (!ResultEnum.SUCCESS.split(',').includes(data?.code?.toString())) {
    //     console.log('response', response)
    //     message.error({
    //       content: data.message,
    //       duration: 3000,
    //       key: 'global-error',
    //     })
    //   }

    //   return data
    // },
  })

  nuxtApp.provide('http', fetch)
})
